module.exports = __webpack_public_path__ + "static/media/favicon-divino-amor copy.4822d0b0.ico";